export default "__VITE_ASSET__CPuTz6kr__"